module.exports = __webpack_public_path__ + "img/IMG_1454_L_Foamcore_MockedUp.8554348d.jpg";